import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconWallet3: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="wallet-3"><path d="M16.25 8.75H6C4.75736 8.75 3.75 7.74264 3.75 6.5C3.75 4.98122 4.98122 3.75 6.5 3.75H16.25V8.75ZM16.25 8.75H20.25V20.25H6.75C5.09315 20.25 3.75 18.9069 3.75 17.25V7.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M15.5 15.25C15.9142 15.25 16.25 14.9142 16.25 14.5C16.25 14.0858 15.9142 13.75 15.5 13.75C15.0858 13.75 14.75 14.0858 14.75 14.5C14.75 14.9142 15.0858 15.25 15.5 15.25Z" fill="currentColor" stroke="currentColor" strokeWidth="0.5"/></CentralIconBase>;
};

export default IconWallet3;
